export default __webpack_public_path__ + "static/media/icon_radiobutton-inactive.d08a89ad.svg";